import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecorderComponent } from './components/recorder/recorder.component';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { AudioModalComponent } from './audio-modal/audio-modal.component';
import { AudioRecordingService } from '../core/services/recorder-service/recorder.service';
import { FinalUserRestService } from 'src/providers/final-user-restservice';
import { globals } from 'src/utils/globals';
import { LocalStorageService } from 'src/services/local-storage.service';
import { TransferStateService } from 'src/services/transfer-state.service';
import { DeviceDetectorService } from 'src/services/device-detector.service';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ResponseModalComponent } from './response-modal/response-modal.component';
import { DeleteuserModalComponent } from './deleteuser-modal/deleteuser-modal.component';
import { FileRestService } from 'src/providers/file-restservice';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule, HttpHandler } from '@angular/common/http';
import { UserRestService } from 'src/providers/user-restservice';
import { UrlService } from 'src/services/url-service';
import { LegalTermsComponent } from './layouts/legal-terms.component/legal-terms.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule
  ],
  declarations: [
    RecorderComponent,
    HeaderComponent,
    FooterComponent,
    AudioModalComponent,
    ResponseModalComponent,
    DeleteuserModalComponent,
    LegalTermsComponent
  ],
  exports:[
    RecorderComponent,
    HeaderComponent,
    FooterComponent,
    AudioModalComponent,
    TranslateModule,
    LegalTermsComponent
  ],
  providers: [
    AudioRecordingService,
    FinalUserRestService,
    FileRestService,
    globals,
    LocalStorageService,
    TransferStateService,
    DeviceDetectorService,
    MdbModalService,
    HttpClient,
    UserRestService,
    UrlService
  ],
})
export class SharedModuleModule { }
